const getMultiLineStringFromPolylines = (sections: any[]): any => {
  const lineStrings: any[] = [];

  sections.forEach((section) => {
    lineStrings.push(window.H.geo.LineString.fromFlexiblePolyline(section.polyline));
  });

  return new window.H.geo.MultiLineString(lineStrings);
};

export const getHereRouteBounds = (routes: any[]) => {
  const rect = routes.reduce((acc, directionRoute, index) => {
    const boundingBox = getMultiLineStringFromPolylines(directionRoute.sections).getBoundingBox();
    if (index === 0) {
      return boundingBox;
    }

    return acc.mergeRect(boundingBox);
  }, null);

  return ({
    TopRight: {
      latitude: rect.getTop(),
      longitude: rect.getRight()
    },
    BottomLeft: {
      latitude: rect.getBottom(),
      longitude: rect.getLeft()
    }
  });
};
